import { PanelCard } from '../../../components/ui';
import AreaTrendChart from '../../../components/charts/AreaTrendChart';
import type { AcademicDashboardResponse } from '../../../api/types';

const label = (iso: string) => new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });

export default function TrendCard({ d, className = '' }: { d: AcademicDashboardResponse; className?: string }) {
  const first = d.weekly_trend.find((w) => w.avg_score != null)?.avg_score;
  const last = [...d.weekly_trend].reverse().find((w) => w.avg_score != null)?.avg_score;
  const summary = first != null && last != null
    ? `Weekly average score moved from ${first.toFixed(0)}% to ${last.toFixed(0)}% over ${d.weeks} weeks`
    : 'Weekly average score';
  return (
    <PanelCard className={className} title="Average score over time" subtitle={`Weekly, all grades · last ${d.weeks} weeks`}
      actions={
        <span className="flex gap-3.5 text-xs text-muted">
          <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-[3px] bg-slate" />Average</span>
          <span className="flex items-center gap-1.5"><span className="w-3.5 border-t-2 border-dashed border-accent-ink" />Pass mark</span>
        </span>
      }>
      <AreaTrendChart ariaLabel={summary} passMark={d.pass_score_pct}
        data={d.weekly_trend.map((w) => ({ label: label(w.week_start), value: w.avg_score }))} />
    </PanelCard>
  );
}
